<div class="card">
    <div class="card-header">
        <div class="card-title mb-0">Topup</div>
    </div>
    <div class="card-body"> 
        <div class="mb-3">
            <div class="form-check">
                <input id="topup_only" class="form-check-input" type="checkbox" value="1" [(ngModel)]="data.topup_only" (change)="topupOnlyChange()"/>
                <label for="topup_only" class="form-check-label">Topup Point Only.</label>
            </div>
        </div>
        <hr/>
        <div class="mb-3" *ngIf="!data.topup_only">
            <label for="name" class="form-label">Amount to Topup</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.amount" (input)="topupValueChange()"/>
        </div>
        <div class="mb-3">
            <label for="name" class="form-label">Bonus</label>
            <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.bonus" />
        </div>
        <p class="text-danger" *ngIf="data.amount && data.bonus">Total Wallet Credit Topup : {{data.amount + data.bonus}}</p>
        <hr/>
        
        <ng-container *ngIf="!data.topup_only">
            <div class="mb-3" *ngIf="player.referral_id && referral_rate > 0">
                <label for="name" class="form-label">Referral Commission</label>
                <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.referral_commission" readonly="readonly"/>
            </div>

            <div class="mb-3">
                <label for="name" class="form-label">Point +/-</label>
                <input type="number" class="form-control form-contrl-lg" [(ngModel)]="data.point" [readonly]="setting.credit_calculation_method == 'auto' && setting.credit_calculation_rate" />
            </div>


            <div class="mb-3">
                <label for="name" class="form-label">Bank In To Account</label>
                <ng-select
                    #select
                    class="modal-appended-select"
                    bindLabel="title" 
                    bindValue="id" 
                    [items]="banks"
                    [clearable]="true"
                    [placeholder]="'Select Bank'"
                    appendTo="body"
                    dropdownPosition="auto"
                    [(ngModel)]="data.deposit_bank" >
                    <ng-template ng-label-tmp let-item="item">
                        <div>{{item.title}} ({{item.balance}})</div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div>{{item.title}} ({{item.balance}})</div>
                    </ng-template>
                </ng-select>
            </div>
        </ng-container>
        <button class="btn btn-success w-100 btn-sm" (click)="topup()" type="submit" [disabled]="is_loading_function">Topup</button>
        <button class="btn btn-danger w-100 btn-sm mt-3" (click)="close()" type="button" [disabled]="is_loading_function">Close</button>
    </div>
</div>
